import { APP_BASE_HREF } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ChangeDetectorRef } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { GraphQLComparision } from '../../../enums/GraphQLComparision.enum';
import { ControlWidgetService, EveReportingControlWidgetWidget } from '../../../services/ControlWidgetService.service';
import { GlobalFiltersOptionalService } from '../../../services/DataSourceServices/GlobalFiltersOptionalService.service';
import { GraphQLConnector, GraphQLFilter, IGraphQlService } from '../../../services/GraphQl/IGraphQL.service';
import { EveReportingWidgetType } from '../../widgets/widget.component';



export interface DialogData {
  wheres: GraphQLFilter[];
  header: string;
  selectedCompany: any
}


@Component({
  selector: 'companies-autocomplete',
  templateUrl: 'companies-autocomplete.component.html',
  styleUrls: ['./companies-autocomplete.component.css']
})
export class CompaniesAutoCompleteComponent {

  @Output()
  onSelectCompany: EventEmitter<any> = new EventEmitter<any>();

  selectedCompany: any;
  companies: any[];
  

  constructor(
    public graphQlService: IGraphQlService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
   
  }

  onModelChange($event: any[]) {
    this.selectedCompany = $event;
    this.onSelectCompany.emit(this.selectedCompany);    
  } 
    

  search(event) {
    
    this.graphQlService.getGraphQlResults({
      dataset: "companiesPage",
      selects: [
        {
          field: "name",
          arguments: null
        },
        {
          field: "organisationID",
          arguments: null
        },
        {
          field: "organisationNode",
          arguments: null
        }
      ],
      wheres: [
        { path: "name", comparison: GraphQLComparision.CONTAINS, value: event.query } as GraphQLFilter
      ],
      groupBys: [],
      orderBy: [{ path: "name", descending: false }],
      page: 0,
      pageSize: 10
    }).subscribe(response => {

      this.companies = response.data.companiesPage.items;
   
      this.changeDetectorRef.detectChanges();
    })


  } 
  
}


